import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";

import { PagesComponent } from "./pages/pages.component";
import { BlankComponent } from "./pages/blank/blank.component";
import { SearchComponent } from "./pages/search/search.component";
import { NotFoundComponent } from "./pages/errors/not-found/not-found.component";
import { ErrorComponent } from "./pages/errors/error/error.component";
import { AuthGuard } from "./pages/services/auth.guard";
import { ManageMenusComponent } from "./pages/menus/manage-menus/manage-menus.component";
import { Auth2Guard } from "./auth/auth2.guard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/landing/landing.module").then((m) => m.LandingModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "main",
    component: PagesComponent,
    children: [
      {
        path: "",

        loadChildren: () =>
          import("./pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        data: { breadcrumb: "Dashboard" },
      },
      {
        path: "admin",

        loadChildren: () =>
          import("./pages/admin/admin.module").then((m) => m.AdminModule),
        data: { breadcrumb: "Admin" },
      },
      {
        path: "applications",

        loadChildren: () =>
          import("./pages/applications/applications.module").then(
            (m) => m.ApplicationsModule
          ),
        data: { breadcrumb: "Applications" },
      },

      {
        path: "administration",

        loadChildren: () =>
          import("./pages/config/config/config.module").then(
            (m) => m.ConfigModule
          ),
        data: { breadcrumb: "Setup" },
      },
      {
        path: "group",

        loadChildren: () =>
          import("./pages/group/group.module").then((m) => m.GroupModule),
        data: { breadcrumb: "Group Registration" },
      },
      {
        path: "operation",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/operation/operation.module").then(
            (m) => m.OperationModule
          ),
        data: { breadcrumb: "Group Operation" },
      },
      {
        path: "cdo",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/cdo/cdo.module").then((m) => m.CdoModule),
        data: { breadcrumb: "Group Management" },
      },
      {
        path: "dcdo",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/dcdo/dcdo.module").then((m) => m.DcdoModule),
        data: { breadcrumb: "Group Management" },
      },
      {
        path: "dcdo",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/dcdo/dcdo.module").then((m) => m.DcdoModule),
        data: { breadcrumb: "Group Management" },
      },
      {
        path: "help",
        loadChildren: () =>
          import("./pages/help/help.module").then((m) => m.HelpModule),
        data: { breadcrumb: "Manuals" },
      },
      {
        path: "ded",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/ded/ded.module").then((m) => m.DedModule),
        data: { breadcrumb: "Group Management" },
      },

      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/users/user-management.module").then(
            (m) => m.UserManagementModule
          ),
        data: { breadcrumb: "Manage Users" },
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/logo-signature/logo-signature.module").then(
            (m) => m.LogoSignatureModule
          ),
        data: { breadcrumb: "Manage Logo and Signatures" },
      },
      {
        path: "blank",
        component: BlankComponent,
        data: { breadcrumb: "Blank page" },
      },
      {
        path: "search",
        component: SearchComponent,
        data: { breadcrumb: "Search" },
      },

      {
        path: "menus",
        canActivate: [Auth2Guard],
        component: ManageMenusComponent,
        data: { breadcrumb: "menu" },
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/documents-template/documents-template.module").then(
            (m) => m.DocumentsTemplateModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/roles/roles.module").then((m) => m.RolesModule),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/loans/loan-application/loan-application.module").then(
            (m) => m.LoanApplicationModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import(
            "./pages/loans/list-applied-loans/list-applied-loans.module"
          ).then((m) => m.ListAppliedLoansModule),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import(
            "./pages/loans/loan-disbursement/loan-disbursement.module"
          ).then((m) => m.LoanDisbursementModule),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/loans/loan-management/loan-management.module").then(
            (m) => m.LoanManagementModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/loans/loan-repayments/loan-repayments.module").then(
            (m) => m.LoanRepaymentsModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import(
            "./pages/loans/loan-application-statues/loan-application-statues.module"
          ).then((m) => m.LoanApplicationStatuesModule),
      },

      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/reports/report-settings/report-settings.module").then(
            (m) => m.ReportSettingsModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import(
            "./pages/reports/report-configurations/report-configurations.module"
          ).then((m) => m.ReportConfigurationsModule),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/reports/report-details/report-details.module").then(
            (m) => m.ReportDetailsModule
          ),
      },

      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/gepg-integration/gepg-integration.module").then(
            (m) => m.GepgIntegrationModule
          ),
      },

      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/fund-sources/fund-sources.module").then(
            (m) => m.FundSourcesModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/planrep-integration/planrep-integration.module").then(
            (m) => m.PlanrepIntegrationModule
          ),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/muse-integration/muse-integration.module").then(
            (m) => m.MuseIntegrationModule
          ),
      },

      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import(
            "./pages/loans/loan-advertisement/loan-advertisement.module"
          ).then((m) => m.LoanAdvertisementModule),
      },
      {
        path: "",
        canActivate: [Auth2Guard],
        loadChildren: () =>
          import("./pages/group-back-log/group-back-log.module").then(
            (m) => m.GroupBackLogModule
          ),
      },
    ],

    // canActivate: [AuthGuard],
  },

  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "register",

    loadChildren: () =>
      import("./pages/register/register.module").then((m) => m.RegisterModule),
  },
  { path: "error", component: ErrorComponent, data: { breadcrumb: "Error" } },
  { path: "**", component: NotFoundComponent },
  { path: "not-found", component: NotFoundComponent },
];

export const routing: ModuleWithProviders<unknown> = RouterModule.forRoot(
  routes,
  {
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: "legacy",
    // enableTracing: true
  }
);
